import { render, staticRenderFns } from "./GigChat.htm?vue&type=template&id=9b32b97c&scoped=true&"
import script from "./GigChat.ts?vue&type=script&lang=js&"
export * from "./GigChat.ts?vue&type=script&lang=js&"
import style0 from "./GigChat.scss?vue&type=style&index=0&id=9b32b97c&lang=scss&scoped=true&"
import style1 from "./GigChatLayout.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b32b97c",
  null
  
)

export default component.exports